/**
 * The mounted state strip's states session, so other panels' state edits keep
 * the strip's intent. It lives here, not in mount-state-context, so the
 * behaviors panel can read it without importing the strip's UI module.
 */

import type { StatesSession } from 'trace-viewer/editor';

let mounted: StatesSession | null = null;

/** Make `session` the mounted strip's session. Returns an unregister that clears it if it is still the one mounted. */
export function registerStatesSession(session: StatesSession): () => void {
    mounted = session;
    return () => {
        if (mounted === session) mounted = null;
    };
}

/** The states session of the mounted strip, or null when none is mounted. */
export function getStatesSession(): StatesSession | null {
    return mounted;
}
